<nav class="navbar navbar-expand-lg navbar-light sticky-top">
    <div class="container">
        <a class="navbar-brand" routerLink="/">
            <img src="assets/img/brand/logo_small.png" width="24" height="24" class="d-inline-block mr-2" alt="NoteRadar Logo" loading="lazy">
            <span class="brand-text">Note<span class="brand-highlight">Radar</span></span>
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link" routerLinkActive="active" routerLink="/benefits"><i class="far fa-thumbs-up"></i>Vorteile</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLinkActive="active" routerLink="/features"><i class="fas fa-cubes"></i>Funktionen</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLinkActive="active" routerLink="/demo"><i class="fas fa-laptop"></i>Demo</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLinkActive="active" routerLink="/pricing"><i class="fas fa-euro-sign"></i>Preise</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLinkActive="active" routerLink="/contact"><i class="far fa-envelope"></i>Kontakt</a>
                </li>
            </ul>
            <ul class="navbar-nav ml-auto" *ngIf="router.url != '/login'">
                <div>
                    <button routerLink="/login" class="btn btn-primary login-btn" type="submit">
                        <i class="fas fa-sign-in-alt"></i> Anmelden
                    </button>
                </div>
            </ul>
        </div>
    </div>
</nav>

<div style="margin: 0 0 60px 0">
    <router-outlet/>
</div>

<div class="fixed-bottom">
    <div class="footer text-center">
        <div class="container">
            <ul class="list-inline mb-0">
                <!--<li class="list-inline-item"><a routerLink="/faq">FAQ</a></li>-->
                <li class="list-inline-item"><a routerLink="/imprint">Impressum</a></li>
                <li class="list-inline-item"><a routerLink="/privacy">Datenschutz</a></li>
                <li class="list-inline-item"><a routerLink="/terms">AGB</a></li>
            </ul>
        </div>
    </div>
</div>
